// extracted by mini-css-extract-plugin
export default {"container":"Disclosures_container__zksJ9"};